(function ($) {
	$(document).ready(function () {
		$("#pressCategory").on("change", function () {
			const url = $(this).val();
			if (url) {
				window.location = url;
			}
			return false;
		});
	});
})(jQuery);
